import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-plan-expired',
  templateUrl: './modal-plan-expired.component.html',
  styleUrls: ['./modal-plan-expired.component.scss']
})
export class ModalPlanExpiredComponent implements OnInit {

  constructor(
    public bsModalRef: BsModalRef
  ) { }

  ngOnInit(): void {
  }

}
